import { createSlice } from '@reduxjs/toolkit';
import { NavigationSyncState } from '../models/state.model';

const initialState: NavigationSyncState = {
  hydrated: false,
};

const NavigationSyncSlice = createSlice({
  name: 'navigationSync',
  initialState,
  reducers: {
    markHydrated(state) {
      state.hydrated = true;
    },
  },
});

export const { markHydrated } = NavigationSyncSlice.actions;

const NavigationSyncReducer = NavigationSyncSlice.reducer;
export default NavigationSyncReducer;